import { UserCredential } from 'firebase/auth';
import { postIdTokens } from '@assetron/common/api';
import { EMPTY_STRING } from '@assetron/common/constants/constant';
import setSameSiteCookieWithoutExpiry from '@assetron/common/utils/setSameSiteCookieWithoutExpiry';
import { IS_USER_LOGGED_IN } from '@assetron/web-common/constants/LocalStorageConstants';
import checkAndHandlePendingCred from './checkAndHandlePendingCred';
import { QueryParamPersistence } from '@assetron/web-common/utils/queryParamPersistence';

export const postIdTokensAndRedirect = async (
  result: UserCredential,
  redirectUrl: string,
  defaultUrl: string,
) => {
  const idToken = await result.user?.getIdToken();
  const refreshToken = result.user?.refreshToken ?? EMPTY_STRING;

  await postIdTokens({
    idToken: idToken ?? EMPTY_STRING,
    refreshToken,
  });

  await checkAndHandlePendingCred(result);

  setSameSiteCookieWithoutExpiry(IS_USER_LOGGED_IN, 'true');
  window.sessionStorage.clear();

  // Get the final redirect URL with persisted query parameters
  const finalRedirectUrl = QueryParamPersistence.getReturnUrlWithQueryParams(
    redirectUrl.length > 0 ? redirectUrl : defaultUrl,
  );

  window.location.replace(finalRedirectUrl);
};
